<template>
  <div class="page_pendInvoiceMul">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing', query:{activeName:'2'} }">发票待办</el-breadcrumb-item>
          <el-breadcrumb-item>{{ type=='sign' ? '手工登记开票' : '开票'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_employee_box" v-if="isOver" v-loading="loading">
        <div class="p_employee_list">
          <div class="r_edit_title">
            <div class="line_box"></div>基础信息
            <div class="flex nums">
              <div>笔数： {{ids.length}} 笔 </div>
              <div style="margin-left:30px">开票金额小计：￥{{sum}} </div>
            </div>
          </div>
          <div class="inv_box" v-for="(item,i) in appInfo" :key="i">
            <div class="p_employee_box" v-loading="loading">
              <div class="p_employee_list">
                <div class="p_employee_form">
                  <div class="p_employee_item">
                    <p class="emp_txt">开票申请编号:</p>
                    <div class="emp_form_txt">
                      {{item.invoiceNo}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <!-- 项目或部门 -->
                    <p class="emp_txt">开票项目/部门:</p>
                    <div class="emp_form_txt">
                      {{item.ownershipName}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <p class="emp_txt">法务主体:</p>
                    <div class="emp_form_txt">
                      {{xsInfo.title}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <p class="emp_txt">开票抬头:</p>
                    <div class="emp_form_txt">
                      {{item.invoiceTitle}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <p class="emp_txt">状态:</p>
                    <div class="emp_form_txt">
                      {{item.status}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <p class="emp_txt">申请人:</p>
                    <div class="emp_form_txt">
                      {{item.applicant}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <p class="emp_txt">电话:</p>
                    <div class="emp_form_txt">
                      {{item.telephone}}
                    </div>
                  </div>
                  <div class="p_employee_item">
                    <p class="emp_txt">申请时间:</p>
                    <div class="emp_form_txt">
                      {{item.applicationTime ? item.applicationTime.replace('T',' ') : '' }}
                    </div>
                  </div>
                </div>
                <div class="p_employee_list">
                  <div class="r_edit_title">
                    <div class="line_box"></div>发票申请
                  </div>
                  <el-table class="doc_table" border :data="invoiceRequisitionDetailsViewList[i].item" style="width:100%;margin-top: 10px">
                    <el-table-column align="center" prop="invoiceItem" label="发票项目" min-width="200px">
                    </el-table-column>
                    <el-table-column align="center" prop="type" label="发票类型" min-width="150px" fit :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column align="center" prop="invoicingName" label="开票内容" min-width="200px" fit :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column align="center" prop="applyForAmount" label="开票金额" min-width="200px" fit :show-overflow-tooltip="true">
                      <template slot-scope="{row}"> ￥ {{ row.applyForAmount}} {{ row.taxInclusiveLabel==1 ? '（含税）' : '（不含税）' }}</template>
                    </el-table-column>
                  </el-table>
                  <div class="merge" style="font-size: 14px;">开票备注：
                    <span v-show="!isEdit">
                      {{item.billingNote}}
                      <i class="el-icon-edit cp icon-01" @click="isEdit = true"></i>
                    </span>
                    <el-input v-show="isEdit" v-model="item.billingNote" size="small" style="width: 300px;"></el-input>
                    <el-button v-show="isEdit" type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEditBillingNote">保存</el-button>
                  </div>
                  <div class="merge flex">
                    <el-checkbox v-model="item.isConsolidatedBilling" :true-label="1" :false-label="0" disabled>服务费/管理费与工资/社保/个税合开在一张发票上（仅适用差额开票）</el-checkbox>
                    <!-- <div class="sumAmount">开票金额合计：￥{{ applyForAmount[i].sum }}</div> -->
                  </div>
                </div>
                <div class="p_employee_list">
                  <div class="r_edit_title">
                    <div class="line_box"></div>对应结算单
                  </div>
                  <div class="dtl_table">
                    <el-table border :data="item.finalStatementViewList" style="width:100%">
                      <!-- 项目或部门 -->
                      <el-table-column align="center" label="项目/部门" min-width="160px">
                        <template slot-scope="{row}">
                          <span>{{row.ownershipName}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="归属月" min-width="110px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                          <span>{{row.ownershipMonth}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="结算单编号" min-width="110px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                          <span>{{row.finalStatementNo}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="结算单金额" min-width="110px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                          <span>{{row.settlementAmount}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="本次开具金额" min-width="100px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                          <span>{{row.amountApplied}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="创建时间" min-width="100px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                          <span>{{row.createTime ? row.createTime.replace('T',' ') : ''}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" label="附件" min-width="160px" fit :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                          <div class="blueName cp" v-for="(item,index) in row.files" :key="index" @click="down2(item.fileUrl,item.fileName)">{{ item.fileName }}</div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <p class="d_txt">结算单本次开具发票金额小计： ￥{{ amountSum[i].sum }}</p>
                </div>
                <div class="emailBox flex">
                  <el-checkbox v-model="item.isInvoiceMail" :true-label="1" :false-label="0" disabled>自动邮件发送电子/数电发票</el-checkbox>
                  <div class="emails">接收邮箱：{{ item.emails[0] ? item.emails[0] : '无' }}</div>
                  <el-checkbox v-model="item.isStatementMail" :true-label="1" :false-label="0" disabled>费用结算单盖章一并电子邮件发送</el-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="chkBox">
            <el-checkbox v-model="handelData.sfzsxsfyhzh">是否展示销售方银行信息</el-checkbox>
            <el-checkbox v-model="handelData.sfzsgmfyhzh">是否展示购买方银行信息</el-checkbox>
            <el-checkbox v-model="handelData.sfzsxsfdzdh">是否展示销售方地址、电话</el-checkbox>
            <el-checkbox v-model="handelData.sfzsgmfdzdh">是否展示购买方地址、电话</el-checkbox>
            <el-checkbox v-model="handelData.isautoremark">是否显示备注</el-checkbox>
          </div>
          <div class="btn_box">
            <el-button type="warning" @click="beforeSave(false)" :loading="isBtnLoading" :disabled="isSuccess" v-if="type!='sign'">{{isSuccess ? '已开票' : '在线开票'}}</el-button>

            <!-- <el-popconfirm title="请确认是否登记手工开票？" @confirm="handelSign" style="margin: 0 10px;" :disabled="isSuccess">
              <el-button type="primary" slot="reference" @click="beforeSave(true)" :disabled="isSuccess">登记手工开票</el-button>
            </el-popconfirm> -->
            <el-button type="primary" @click="beforeSave(true)" :disabled="isSuccess">登记手工开票</el-button>
            <!-- <el-button @click="downInvoice" v-if="type!='sign' && isSuccess" :loading="isBtnLoading">下载发票</el-button> -->
            <el-button @click="backHandle">返 回</el-button>
          </div>
        </div>
      </div>

      <el-dialog title="登录" :visible.sync="showLogin" width="530px" class="res_dialog enter_dialog">
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="re_down_form" label-width="100px">
          <el-form-item label="法务主体:">
            {{ loginForm.qymc }}
          </el-form-item>
          <el-form-item label="税号:">
            <el-input v-model="loginForm.nsrsbh" size="small" clearable style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="zrrsjh">
            <el-input v-model="loginForm.zrrsjh" size="small" clearable style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="登录密码:" prop="zrrmm">
            <el-input v-model="loginForm.zrrmm" size="small" clearable style="width: 300px"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showLogin = false" size="small">取消</el-button>
          <el-button type="primary" @click="confirmLogin" size="small" :loading="isBtnLoading">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="认证" :visible.sync="showAuthentication" width="450px">
        <div :loading="qrLoading">
          <el-form>
            <el-form-item label="二维码类型:">
              <el-select v-model="ewmlx" size="small" @change="changeEwmlx" placeholder="" style="width: 180px;">
                <el-option label="税务APP" :value="1">
                </el-option>
                <el-option label="个税APP" :value="2">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <el-image style="width: 300px; height: 300px;margin-left:50px" v-if="QRCodeSrc" :src="QRCodeSrc" alt="" @click="getQRCode"></el-image>
        <div class="qrTips" v-if="qrLoading">二维码加载中...</div>
        <!-- <el-button>重新获取二维码</el-button> -->
        <div v-if="isTimeout" class="qrTips">网络连接超时或异常</div>
        <div class="qrTips" v-if="ewmlx && !qrLoading">请使用{{ewmlx==1?'税务APP' : '个税APP'}}扫码认证</div>
        <!-- <div @click="getQRStatus">111</div> -->
      </el-dialog>
      <el-dialog title="选择发票格式" :visible.sync="showDown" width="450px">
        <div>
          <el-form>
            <el-form-item label="发票格式:">
              <el-select v-model="wjlx" size="small" placeholder="" style="width: 180px;">
                <el-option value="PDF">
                </el-option>
                <el-option value="OFD">
                </el-option>
                <el-option value="XML">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDown = false" size="small">取消</el-button>
          <el-button type="primary" @click="confirmDownInvoice" size="small" :loading="isBtnLoading">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="提示" :visible.sync="showConfirm" width="450px">
        <div>
          {{ errMsg }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showConfirm = false" size="small">取消</el-button>
          <el-button type="primary" @click="confirmContinue" size="small" :loading="isBtnLoading">确定</el-button>
        </span>
      </el-dialog>

      <div class="dialog_box">
        <el-dialog :title="!handelData.isOffline ? '在线开票确认' : '手工开票登记'" :visible.sync="showInvoice" width="1200px" style="padding: 0;">
          <div class="com_style pt20 mt15" v-if="showInvoice">
            <el-form :inline="true" :rules="formRules" ref="statementForm" :model="handelData" label-width="100px">
              <el-form-item label="开票方式:" prop="billingItemId">
                <div class="f_sel_box flex">
                  <el-select class="f_sel01" v-model="Billing2" placeholder="" size="small" @change="changeBilling" filterable clearable style="width: 180px">
                    <el-option v-for="(item, index) in BillingList" :key="index" :label="item.value" :value="item"></el-option>
                  </el-select>
                  <el-checkbox v-model="handelData.isConsolidatedBilling" :true-label="1" :false-label="0" v-if="Billing != undefined && Billing.indexOf('差额') > -1" style="margin-left: 15px;" @change="changeConsolidatedBilling">合并开票</el-checkbox>
                </div>
              </el-form-item>
              <el-form-item label="票种:" label-width="60px" prop="actualBillingMain.invoiceTypeId" v-if="Billing != undefined && Billing.indexOf('全额') > -1">
                <el-select v-model="invoiceTypeId" placeholder="" size="small" style="width: 110px" filterable clearable value-key="key" @change="changeTicketTypeId">
                  <el-option v-for="(item, index) in ticketTypeList" :key="index" :label="item.value" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="特殊要求:" label-width="100px" prop="actualBillingMain.invoiceTypeId">
                <el-checkbox v-model="handelData.isPolymerization" @change="changeSupReq" :true-label="1" :false-label="0">相同发票类型和开票内容合并开具</el-checkbox>
              </el-form-item>
              <div v-if="Billing != undefined && Billing.indexOf('全额') > -1 && handelData.actualBillingTakeOut==null">
                <div v-for="(item,index) in handelData.actualBillingMain.details" :key="index">
                  <el-form-item label="开票内容:" prop="actualBillingMain.billingItemDetailsId">
                    <el-select v-model="item.billingItemDetailsId" placeholder="" size="small" filterable clearable value-key="key" style="width: 180px" @change="changeBillingItemDetails">
                      <el-option v-for="(item, index) in BillingConList" :key="index" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="开票金额:" label-width="80px">
                    ￥
                    <el-input type="number" v-model="item.invoiceAmount" size="small" style="width: 100px;" @blur="calMtpt"></el-input>
                  </el-form-item>

                  <el-form-item label="数量:" label-width="50px">
                    <el-input type="number" v-model="item.quantity" size="small" style="width: 80px;"></el-input>
                  </el-form-item>
                  <el-form-item label="单位:" label-width="50px">
                    <el-input v-model="item.unit" size="small" style="width: 80px;"></el-input>
                  </el-form-item>
                  <el-form-item label="规格:" label-width="50px">
                    <el-input v-model="item.specification" size="small" style="width: 80px;"></el-input>
                  </el-form-item>

                  <el-form-item>
                    <div class="injuryTabBtn">
                      <el-button type="text" @click="addContentHandle()">+ 添加</el-button>
                      <el-button type="text" v-if="index!=0" @click="dltContentHandle(index)">删除</el-button>
                    </div>
                  </el-form-item>
                  <el-form-item label="价税合计:" label-width="80px" v-if="index==handelData.actualBillingMain.details.length - 1">
                    <span style="font-weight: bold">￥{{ mTpt.toFixed(2) }}</span>
                  </el-form-item>
                </div>
              </div>
              <div class="ceBox" style="overflow: hidden;" v-if="handelData.actualBillingTakeOut!=null">
                <div class="flex" v-if="handelData.actualBillingMain!=null">
                  <!-- <div class="ceTitle" v-if="handelData.isConsolidatedBilling == 0">服务费</div> -->
                  <el-form-item label="开票内容:" :style="handelData.isConsolidatedBilling == 0 ? 'margin-left:50px' : 'margin-left:13px'">
                    <el-select v-model="handelData.actualBillingMain.details[0].billingItemDetailsId" placeholder="" size="small" filterable clearable value-key="key" style="width: 180px">
                      <el-option v-for="(item, index) in BillingConList" :key="index" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="票种:" label-width="60px" :prop="handelData.isConsolidatedBilling==1 ? 'actualBillingMain.invoiceTypeId' : ''" v-if="handelData.isConsolidatedBilling == 1">
                    <el-select v-model="invoiceTypeId" placeholder="" size="small" style="width: 120px" filterable clearable @change="changeTicketTypeId" value-key="key">
                      <el-option v-for="(item, index) in ticketTypeList" :key="index" :label="item.value" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开票金额:" v-if="handelData.actualBillingMain!=null" type="number" label-width="80px" :prop="handelData.isConsolidatedBilling==1 ? 'actualBillingMain.invoiceAmount' : ''">
                    <el-select v-model="handelData.actualBillingMain.details[0].taxInclusiveLabel" placeholder="" size="small" style="width: 90px;margin-right: 15px">
                      <el-option label="含税" :value="1"></el-option>
                      <el-option label="不含税" :value="0"></el-option>
                    </el-select>
                    <el-input v-model="handelData.actualBillingMain.details[0].invoiceAmount" size="small" style="width: 120px"></el-input>
                  </el-form-item>
                  <el-form-item label="数量:" label-width="50px">
                    <el-input type="number" v-model="handelData.actualBillingMain.details[0].quantity" size="small" style="width: 80px;"></el-input>
                  </el-form-item>
                  <el-form-item label="单位:" label-width="50px">
                    <el-input v-model="handelData.actualBillingMain.details[0].unit" size="small" style="width: 80px;"></el-input>
                  </el-form-item>
                  <el-form-item label="规格:" label-width="50px">
                    <el-input v-model="handelData.actualBillingMain.details[0].specification" size="small" style="width: 80px;"></el-input>
                  </el-form-item>
                  <!-- 
                  <el-form-item label="价税合计:" type="number" label-width="80px" :prop="handelData.isConsolidatedBilling==1 ? 'actualBillingMain.invoiceAmount' : ''">
                    ￥：{{ handelData.actualBillingMain.taxInclusiveLabel == 0 ? handelData.actualBillingMain.invoiceAmount * (rate + 1) :  handelData.actualBillingMain.invoiceAmount }}
                  </el-form-item> -->

                </div>
                <div v-if="handelData.actualBillingMain!=null" class="deductionAmountSum" style="float: right">价税合计:￥：{{ handelData.actualBillingMain.details[0].taxInclusiveLabel == 0 ? (handelData.actualBillingMain.details[0].invoiceAmount * (rate + 1)).toFixed(2) :  Number(handelData.actualBillingMain.details[0].invoiceAmount).toFixed(2) }}</div>

                <div class="flex" style="margin-top: 20px;">
                  <!-- <div class="ceTitle">{{ handelData.isConsolidatedBilling == 0 ? '工资社保等' : '工资社保等（扣除部分）'}}</div> -->
                  <div>
                    <div v-if="handelData.isConsolidatedBilling == 0" style="margin-left: -24px;">
                      <el-form-item label="开票方式:" v-if="handelData.actualBillingTakeOut!=null &&handelData.actualBillingMain!=null">
                        <el-select class="f_sel01" v-model="handelData.actualBillingTakeOut.billingItemId" placeholder="" size="small" filterable clearable @change="val=>{changeBilling2(val,'change')}" style="width: 180px;">
                          <el-option v-for="(item, index) in BillingList" :key="index" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="票种:" label-width="60px" :prop="handelData.isConsolidatedBilling==0 ? 'actualBillingTakeOut.invoiceTypeId' : ''">
                        <el-select v-model="handelData.actualBillingTakeOut.invoiceTypeId" placeholder="" size="small" style="width: 120px" filterable clearable @change="changeInvoiceType2">
                          <el-option v-for="(item, index) in ticketTypeList2" :key="index" :label="item.value" :value="item.key"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="数量:" label-width="50px">
                        <el-input type="number" v-model="handelData.actualBillingTakeOut.details[0].quantity" size="small" style="width: 80px;"></el-input>
                      </el-form-item>
                      <el-form-item label="单位:" label-width="50px">
                        <el-input v-model="handelData.actualBillingTakeOut.details[0].unit" size="small" style="width: 80px;"></el-input>
                      </el-form-item>
                      <el-form-item label="规格:" label-width="50px">
                        <el-input v-model="handelData.actualBillingTakeOut.details[0].specification" size="small" style="width: 80px;"></el-input>
                      </el-form-item>
                      <!-- <el-form-item label="开票金额:" label-width="80px">
                        <el-select v-model="taxInclusiveLabel" placeholder="" size="small" style="width: 90px;margin-right: 15px">
                          <el-option label="含税" :value="1"></el-option>
                          <el-option label="不含税" :value="0"></el-option>
                        </el-select>
                        <el-input v-model="kcamount" size="small" type="number" clearable style="width: 120px"></el-input>
                      </el-form-item> -->
                    </div>
                    <div :class="handelData.isConsolidatedBilling == 0 ? 'ckbox flex' : 'ckbox2 flex'" v-for="(item,index) in handelData.actualBillingTakeOut.details" :key="index" style="width: 100%;">
                      <div v-if="handelData.isConsolidatedBilling == 0" class="kcTitle">开票内容：</div>
                      <el-select v-if="handelData.isConsolidatedBilling == 0" v-model="item.billingItemDetailsId" placeholder="" size="small" filterable clearable value-key="key" style="margin-right: 10px">
                        <el-option v-for="(item, index) in BillingConList2" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                      <div class="kcTitle">扣除项目：</div>
                      <el-input v-model="item.projectName" placeholder="输入扣除项目" size="small" style="width:80px"></el-input>
                      <div class="huo">扣除金额：</div>
                      <el-input v-model="item.deductionAmount" placeholder="输入扣除金额" size="small" type="number" style="width:120px;margin-right:10px" @blur="getDeductionAmountSum"></el-input>
                      <div class="blueName cp addbtn" v-if="index==0" @click="addKcItem">+添加</div>
                      <div class="blueName cp addbtn" v-if="index!=0" @click="delKcItem(index)">删除</div>
                      <div class="deductionAmountSum" v-if="index==handelData.actualBillingTakeOut.details.length - 1">扣除合计：￥{{deductionAmountSum}}</div>
                      <div class="deductionAmountSum" v-if="handelData.actualBillingMain!=null && index==handelData.actualBillingTakeOut.details.length - 1">价税合计: ￥{{ handelData.actualBillingMain.details[0].taxInclusiveLabel == 0 ? (Number(handelData.actualBillingMain.details[0].invoiceAmount * (rate + 1)) + Number(deductionAmountSum)).toFixed(2) : ( Number(handelData.actualBillingMain.details[0].invoiceAmount) + Number(deductionAmountSum)).toFixed(2) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isBuild">
                <div class="r_edit_title">
                  <div class="line_box"></div>
                  建筑服务补充信息
                </div>
                <el-form-item label="土地增值税项目编号:" label-width="160px">
                  <el-input v-model="handelData.buildingData.landValueTaxNo" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="建筑服务发生地:" label-width="160px">
                  <el-input v-model="handelData.buildingData.buildingServiceSite" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="详细地址:" label-width="160px">
                  <el-input v-model="handelData.buildingData.detailedAddress" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="建筑项目名称:" label-width="160px">
                  <el-input v-model="handelData.buildingData.buildingName" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="跨地市标志:" label-width="160px">
                  <el-select v-model="handelData.buildingData.crossCitySigns" placeholder="" size="small" clearable filterable>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </div>

            </el-form>

            <div class="post_list mt15">
              <el-table border :data="appInfo[0].finalStatementViewList" ref="multipleTable" class="doc_table" style="width: 100%">
                <el-table-column align="center" prop="ownershipName" label="项目" min-width="120px">
                </el-table-column>
                <el-table-column align="center" prop="ownershipMonth" label="归属月" min-width="100px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="finalStatementNo" label="结算单编号" min-width="100px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="settlementAmount" label="结算单金额" min-width="80px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="outstandingAmount" label="剩余待开金额" min-width="120px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" label="本次开具金额" min-width="120px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ $index }">
                    <el-input type="number" v-model="handelData.actualBillingForFinalStatement[$index].amount" size="small" clearable></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" min-width="120px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <span>{{row.createTime ? row.createTime.replace("T", " ") : ""}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="附件" min-width="100px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <div v-for="(item,index) in row.files" :key="index" class="blueName cp" @click="down2(item.fileUrl,item.fileName)">{{ item.fileName }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="r_edit_title" style="margin-top: 15px">
              <div class="line_box"></div>
              可用额度
            </div>
            <div class="flex aic" v-loading="limltIng" element-loading-text="正在查询可用额度">
              <div class="limltTitle">可用授信额度：</div>
              <div class="limlt">{{kysxed}}</div>
              <div class="limltTitle">总授信额度：</div>
              <div class="limlt">{{zsxed}}</div>
              <div class="limltTitle">当前可用纸票数量：</div>
              <div class="limlt">{{dqkyzpsl}}</div>
              <el-button type="success" size="small" @click="getLimit(true)" v-preventReClick>重新查询</el-button>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <div class="tips" v-if="baseInfo[0].remark">申请备注：{{ baseInfo[0].remark }}</div>
            <el-button @click="showInvoice = false" size="small">取消</el-button>
            <el-button type="warning" @click="invView" size="small">发票预览</el-button>
            <el-button type="primary" @click="beforeSubmit" size="small" :loading="isBtnLoading" v-if="!handelData.isOffline">确定</el-button>
            <el-button type="primary" @click="saveHandle" size="small" :loading="isBtnLoading" v-if="handelData.isOffline">确定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="发票预览" :visible.sync="showInvView" width="1000px">
          <div v-if="showInvView">
            <div :class="i>0 ? 'tabBox invTop' : 'tabBox'" v-for="(inv,i) in invList" :key="i">
              <div class="invTitle">
                <div class="invType">{{ inv.isBuild ? '建筑服务' : inv.methods==2 ? '差额征税 - 差额开票' : '' }}</div>
                <div class="centerTitle">
                  <div class="reimbursementTitle">电子发票{{ inv.ticketType=='普票' ? '（普通发票）'  : '（增值税专业发票）'}}</div>
                  <hr :width="inv.ticketType=='普票' ? '220px' : '300px'" color="#800000" style="margin-top:-1px;border-color:#800000;" height="1px">
                  <hr :width="inv.ticketType=='普票' ? '220px' : '300px'" color="#800000" style="margin-top:-5px;border-color:#800000;" height="1px">
                </div>
                <div style="min-width: 150px;">
                  <div><span class="invNum">发票号码：</span>XXXXXXX</div>
                  <div><span class="invNum">开票日期：</span>XXXXXXX</div>
                </div>
              </div>
              <table width="100%" border="0" cellspacing="1" cellpadding="4" class="invoiceTable" align="center">
                <tr>
                  <td width="2.5%" class="font-center titfont">购买方信息</td>
                  <td width="47.5%" colspan="19">
                    <div>
                      <div class="rowItem">
                        <span class="rowTitle">名称：</span>
                        {{ appInfo[0].invoiceTitle }}{{ baseInfo[0].isNaturalPerson == 1 ? '（个人）' : '' }}
                      </div>
                      <div class="rowItem mt">
                        <span class="rowTitle">统一社会信用代码/纳税人识别号：</span>
                        {{baseInfo[0].ratepayerNo}}
                      </div>
                    </div>
                  </td>
                  <td width="2.5%" class="font-center titfont">销售方信息</td>
                  <td width="47.5%" colspan="19">
                    <div>
                      <div class="rowItem">
                        <span class="rowTitle">名称：</span>
                        {{xsInfo.title}}
                      </div>
                      <div class="rowItem mt">
                        <span class="rowTitle">统一社会信用代码/纳税人识别号：</span>
                        {{xsInfo.ratepayerNo}}
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colspan="40">
                    <div class="invInfoBox">
                      <div class="flex">
                        <div class="invItem" style="width: 140px;">项目名称</div>
                        <div class="invItem">规格型号</div>
                        <div class="invItem" style="width: 80px;">单&nbsp;&nbsp;&nbsp;&nbsp;位</div>
                        <div class="invItem" style="width: 80px;">数&nbsp;&nbsp;&nbsp;&nbsp;量</div>
                        <div class="invItem">单&nbsp;&nbsp;&nbsp;&nbsp;价</div>
                        <div class="invItem">金&nbsp;&nbsp;&nbsp;&nbsp;额</div>
                        <div class="invItem">税率/征收率</div>
                        <div class="invItem">税&nbsp;&nbsp;&nbsp;&nbsp;额</div>
                      </div>
                      <div class="invInfoLine flex" v-for="(item,index) in inv.details" :key="index">
                        <!-- <div style="width: 500px;">{{ item.billingItem }}</div> -->
                        <div class="invInfoItem" style="width: 140px;">{{ item.billingItem }}</div>
                        <div class="invInfoItem">{{ item.specification }}</div>
                        <div class="invInfoItem" style="width: 80px;">{{ item.unit }}</div>
                        <div class="invInfoItem" style="width: 80px;">{{ item.quantity }}</div>
                        <div class="invInfoItem"></div>
                        <div class="invInfoItem">{{ item.amount }}</div>
                        <div class="invInfoItem">{{ inv.methods==1 ? (inv.rate*100 + '%' )  : '***'}}</div>
                        <div class="invInfoItem">{{ item.taxAmount }}</div>
                      </div>
                      <div class="invInfoBot flex">
                        <div class="invItem" style="width: 200px;">合&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计</div>
                        <div style="width: 300px;"></div>
                        <div class="invInfoItem">￥{{ inv.totalAmount }}</div>
                        <div class="invInfoItem"></div>
                        <div class="invInfoItem">￥{{  inv.totalTax }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="40">
                    <div class="amountLine flex">
                      <div class="invItem" style="width: 200px;border-right: 1px solid #800000;">价税合计（大写）</div>
                      <div style="width: 300px;">ⓧ{{ numberToChinese(inv.totalTaxPrice) }}</div>
                      <div>
                        <span>（小写）</span>
                        ￥{{inv.totalTaxPrice}}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td width="2.5%" class="font-center titfont titfont2">备 注</td>
                  <td colspan="39">
                    <div class="invRemake" v-if="inv.methods==2">扣除额：{{ handelData.isConsolidatedBilling == 0 ? inv.totalAmount : inv.totalDeductionAmount }} 。</div>
                    <div class="invRemake" v-if="handelData.sfzsxsfyhzh">销方开户银行:{{appInfo[0].openingBank}}; 银行账号:{{appInfo[0].bankAccount}};</div>
                    <div class="invRemake" v-if="handelData.sfzsgmfyhzh">购方开户银行:{{appInfo[0].bankOfDeposit}}; 银行账号:{{appInfo[0].accountNumber}};</div>
                    <div class="invRemake">{{ baseInfo[0].billingNote}}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showInvView = false" size="small">关 闭</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
  import xz from "@/common"
  import {
    e
  } from "mathjs";
  import moment from 'moment'
  import * as math from 'mathjs'
  import print from 'print-js'
  import {
    parse
  } from "qs";

  export default {
    name: "updatePost",
    data() {
      return {
        wjlx: 'PDF',
        showDown: false,
        showInvoice: false,
        baseInfo: [],
        ids: [],
        loading: false,
        isEdit: 'dtl',
        // 详情参数
        dtlQuery: {
          mainuserid: '',
          useridr: ''
        },
        tableData: [],
        id: '',
        isSuccess: false,
        isBtnLoading: false,
        appInfo: [], //f发票信息
        invoiceFiles: [], //结算单附件
        isOver: false,
        sum: 0,
        type: '',
        actualInvoiceViewList: [],
        showAuthentication: false,
        qrLoading: false,
        QRCodeSrc: '',
        ewmlx: null,
        qrLoading: false,
        limltIng: false,
        showLogin: false,
        showDtl: false,
        amountSum: [],
        invoiceRequisitionDetailsViewList: [],
        subjectOfLegalAffairsId: '',
        loginForm: {
          qymc: '', //企业名称
          nsrsbh: '', //纳税人识别号
          areaid: '', //行政区划代码
          ljlx: 'PC', //链接类型 PC、H5
          rzcghddz: '', //认证成功回调地址(base64编码)
          ycsbhddz: '', //异常失败回调地址(base64编码
          fhdz: '', //H5页面返回地址(base64编码)
          zrrsf: 14, //自然人身份1：办税员2：法定代表人3：财务负责人6：领票人8：社保经办人14：开票员
          // zrrsjh: '', //自然人手机号
          // zrrmm: '', //自然人密码
        },
        aaa: {
          ljlx: 'PC', //链接类型 PC、H5
          zrrsjh: '', //认证成功回调地址(base64编码)
          zrrmm: '', //异常失败回调地址(base64编码
          fhdz: '', //H5页面返回地址(base64编码)
        },
        isTimeout: false,
        interval: null,
        rzid: '',
        loginRules: {
          zrrsjh: {
            required: true,
            message: "请输入登录手机",
            trigger: "blur",
          },
          zrrmm: {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        },
        ownershipId: '',
        BillingList: [], //开票方式列表
        Billing: '', //开票方式
        Billing2: '', //开票方式
        billingItemDetails: '', //开票内容
        ticketTypeList: [],
        BillingConList: [], //开票内容列表
        businessTypeId: '',
        invoiceTypeId: '', //票种
        ticketTypeList2: [],
        rate: 0, //税率
        settlementAmountSum: 0,
        deductionAmountSum: 0, //扣除合计
        handelData: {
          invoiceId: '', //发票id
          isPolymerization: 1, //是否聚合1：是0：否
          isConsolidatedBilling: 0, //是否合并
          actualBillingForFinalStatement: [{ //发票结算单关联详细
            invoiceForFinalStatementId: "", //申请id
            amount: 0 //本次开具金额
          }], //
          actualBillingMain: {
            billingItemId: '',
            invoiceTypeId: "", //票种id
            details: [{
              billingItemDetailsId: "", //开票内容id
              taxInclusiveLabel: 0, //是否含税1：含税0：不含税
              invoiceAmount: 0, //金额
            }],
          },
          actualBillingTakeOut: {
            billingItemId: '',
            invoiceTypeId: '',
            details: [{
              billingItemDetailsId: '',
              projectName: '',
              deductionAmount: 0
            }],
          },
          buildingData: { //建筑服务补充信息
            landValueTaxNo: "", //土地增值税项目编号
            buildingServiceSite: "", //建筑服务发生地
            detailedAddress: "", //详细地址
            buildingName: "", //建筑项目名称
            crossCitySigns: null //跨地市标志1:是0：否
          },
          isOffline: false, //是否线下申请（手工）
          sfzsxsfyhzh: true, //是否在展示销售方银行信息
          sfzsgmfyhzh: false, //是否展示购买方银行信息
          sfzsxsfdzdh: false, //是否展示销售方地址、电话
          sfzsgmfdzdh: false, //是否展示购买方地址、电话
          isautoremark: true,
          gmfxxsfqr: false, //购买方信息是否确认
          sxeddefptxgz: false, //是否确认开具大额发票
          spflxqr: false, //是否确认受票方为单位
          drawer: Cookies.get("userid-b"), //开票人
        },
        formRules: {
          'invoiceTitle': {
            required: true,
            message: "请选择开票抬头",
            trigger: "change",
          },
        },
        mTpt: 0, //main部分 价税合计
        showInvView: false,
        xsInfo: { //销售方信息
          title: '',
          ratepayerNo: '',
        },
        ticketType: '',
        BillingConList2: [],
        mainInfo: null, //全额部分
        outInfo: null, //差额部分
        showConfirm: false,
        errMsg: '',
        errField: '',
        outBilling: '',
        isBuild: false,
        kysxed: '', //可用授信额度
        zsxed: '', //总授信额度
        dqkyzpsl: '', //当前可用纸票数量
        isEdit: false,
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.type = this.$route.query.type;
        this.ids = this.$route.query.id.split(',')
        this.ids.forEach((element, index) => {
          this.invoiceRequisitionDetailsViewList.push({
            item: []
          })
          this.GetInvoiceApplyForView(element, index)
          this.GetInvoiceEdit(element, index)
        });
        this.id = this.$route.query.id;
      }
    },
    beforeDestroy() {
      // 清除setInterval
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    methods: {
      //打印
      printClick(id, ignoreIds) {
        const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
        setTimeout(function () {
          printJS({
            printable: id, // 标签元素id
            type: 'html',
            targetStyles: ['*'],
            style: `.page{margin:10px;height:2000px};table{border-collapse:separate}`,
          });
        }, 500)
      },
      GetInvoiceEdit(id, index) {
        xz.GetInvoiceEdit(id).then((res) => {
          if (res.status == 'ok') {
            this.baseInfo.push(res.data[0])
            if (index == 0) {
              this.subjectOfLegalAffairsId = res.data[0].subjectOfLegalAffairsId;
              this.getQYinfo();
              this.ownershipId = res.data[0].ownershipId;
              this.handelData.invoiceId = id;
              this.handelData.buildingData = res.data[0].buildingData;
              // this.handelData.billingItemId = res.data[0].billingItemId;
              this.handelData.actualBillingForFinalStatement = res.data[0].invoiceForFinalStatementsList;
              this.GetInvoiceEditDetails(id)
            }
          } else {}
        })
      },
      changeSupReq(val) {
        this.GetInvoiceEditDetails(this.ids[0])
      },
      GetInvoiceEditDetails(id) {
        xz.GetInvoiceEditDetails(id, this.handelData.isPolymerization == 1 ? true : false).then((res) => {
          if (res.status == 'ok') {
            this.handelData.isConsolidatedBilling = res.data[0].isConsolidatedBilling;
            this.handelData.actualBillingMain = res.data[0].actualBillingMain;
            this.handelData.actualBillingTakeOut = res.data[0].actualBillingTakeOut;
            this.GetBillingItem();
            if (this.handelData.actualBillingMain != null) {
              this.GetTicketType(this.handelData.actualBillingMain.billingItemId)
              this.calMtpt()
            } else if (this.handelData.actualBillingTakeOut != null) {
              this.GetTicketType(this.handelData.actualBillingTakeOut.billingItemId)
              // this.changeBillingItemDetails2(this.handelData.actualBillingTakeOut.billingItemDetailsId)
              this.getDeductionAmountSum()
            }
            if (this.handelData.actualBillingMain != null && this.handelData.actualBillingTakeOut != null) {
              this.changeBilling2(this.handelData.actualBillingTakeOut.billingItemId, 'csh')
              this.changeInvoiceType2()
              this.getDeductionAmountSum()
            }
          }
        })
      },
      getDeductionAmountSum() {
        let sum = 0;
        this.handelData.actualBillingTakeOut.details.forEach(element => {
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(element.deductionAmount))
            )
          )
        });
        this.deductionAmountSum = parseFloat(sum);
      },
      GetBillingItem() {
        xz.GetBillingItem(this.subjectOfLegalAffairsId).then((res) => {
          if (res.status == "ok") {
            this.BillingList = res.data;
            //开票方式赋值
            let d = {
              key: this.handelData.actualBillingMain != null ? this.handelData.actualBillingMain.billingItemId : this.handelData.actualBillingTakeOut.billingItemId,
              value: ''
            }
            this.BillingList.forEach(element => {
              if (element.key == d.key) {
                d.value = element.value;
                this.Billing2 = d;
                this.Billing = element.value;
                if (this.Billing2.value.indexOf('全额') > -1 && this.handelData.actualBillingMain == null) {
                  this.handelData.actualBillingMain = {
                    invoiceTypeId: "", //票种id
                    billingItemDetailsId: "", //开票内容id
                    taxInclusiveLabel: 0, //是否含税1：含税0：不含税
                    invoiceAmount: 0, //金额
                    quantity: null,
                    unit: null,
                    specification: null,
                  }
                } else if (this.Billing2.value.indexOf('差额') > -1 && this.handelData.actualBillingTakeOut == null) {
                  this.handelData.actualBillingTakeOut = {
                    invoiceTypeId: '',
                    billingItemDetailsId: this.handelData.actualBillingMain != null ? this.handelData.actualBillingMain.billingItemDetailsId : '',
                    details: [{
                      projectName: '',
                      deductionAmount: 0,
                      quantity: null,
                      unit: null,
                      specification: null,
                    }],
                  }
                }
              }
            });
            // console.log(this.Billing2, this.Billing)
            this.GetBillingItemDetails(d.key);
          } else {
            this.BillingList = [];
          }
        });
      },
      // 取消
      backHandle() {
        // this.$router.push({
        //   path: "/invoicing",
        // });
        window.close()
      },
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
      },
      //获取详情
      GetInvoiceApplyForView(id, index) {
        this.loading = true;
        xz.GetInvoiceApplyForView(id).then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              this.loading = false;
              this.appInfo.push(res.data[0]);
              this.invoiceRequisitionDetailsViewList[index].item = res.data[0].invoiceRequisitionDetailsViewList;
              let sum = 0;
              res.data[0].finalStatementViewList.forEach(element => {
                console.log(this.sum, element.amountApplied)
                sum = math.format(
                  math.add(
                    math.bignumber(Number(sum)), math.bignumber(Number(element.amountApplied))
                  )
                )
              });
              this.amountSum.push({
                sum: parseFloat(sum)
              });
              this.isOver = true;
              if (index == this.ids.length - 1) {
                this.sum = 0
                this.appInfo.forEach(element => {
                  this.sum = math.format(
                    math.add(
                      math.bignumber(Number(this.sum)), math.bignumber(Number(element.sumAmountApplied))
                    )
                  )
                  this.sum = parseFloat(this.sum)
                });
              }
            } else {
              this.loading = false;
              this.$message.error('获取详情出错')
            }
          } else {
            this.loading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //获取企业登录信息
      getQYinfo() {
        xz.GetCorporationData(this.subjectOfLegalAffairsId).then((res) => {
          if (res.status == "ok") {
            this.xsInfo = {
              title: res.data.strLegalsubName,
              ratepayerNo: res.data.taxNum
            }
            this.loginForm = {
              qymc: res.data.strLegalsubName,
              nsrsbh: res.data.taxNum,
              areaid: res.data.value,
              ljlx: 'PC', //链接类型 PC、H5
              rzcghddz: '', //认证成功回调地址(base64编码)
              ycsbhddz: '', //异常失败回调地址(base64编码
              fhdz: '',
              zrrsf: 14, //自然人身份1：办税员2：法定代表人3：财务负责人6：领票人8：社保经办人14：开票员
            };
            let encode = encodeURI(window.location.href + '&status=back');
            let base64 = btoa(encode)
            this.loginForm.rzcghddz = base64;
            this.loginForm.ycsbhddz = base64;
            this.loginForm.fhdz = base64;
            this.getLimit(false);
            if (this.$route.query.status != undefined && this.$route.query.status.indexOf('back') > -1) {
              // this.actualInvoiceViewList = this.$route.query.actId.split(',');
              this.PostThirdParty_subscribe()
              // this.showInvoice = true;
              // console.log(this.actualInvoiceViewList)
            } else {
              if (!res.data.isonline) {
                this.showLogin = true;
              }
            }
            // this.actualInvoiceViewList = ['f8fe5797-6114-4dd9-be6f-285549115c5c'];
            // this.PostThirdParty_blueBilling()
          } else {}
        });
      },
      //获取主体额度
      getLimit(type) {
        let d = {
          qymc: this.loginForm.qymc,
          nsrsbh: this.loginForm.nsrsbh,
          areaid: this.loginForm.areaid,
        }
        this.limltIng = true;
        xz.IvoiceFun(d, 'PostThirdParty_queryBillingDataOverview').then(res => {
          if (res.status == 'ok') {
            try {
              this.kysxed = res.data.kysxed; //可用授信额度
              this.zsxed = res.data.zsxed; //总授信额度
              this.dqkyzpsl = res.data.dqkyzpsl; //当前可用纸票数量
              this.limltIng = false;
            } catch {
              this.$message.error('获取额度信息异常')
              this.kysxed = 0; //可用授信额度
              this.zsxed = 0; //总授信额度
              this.dqkyzpsl = 0; //当前可用纸票数量
              this.limltIng = false;
            }
            if (type && res.data.cwxx != undefined && res.data.cwxx.indexOf('登录') > -1) {
              setTimeout(() => {
                this.showLogin = true;
              }, 500);
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 5000
            })
          }
        })
      },
      down(url) {
        d = url.replace("\"", "").replace("\"", "");
        var path = this.$store.state.EMP.docPath + d;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      down2(url, name) {
        var path = this.$store.state.EMP.docPath + url;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = name;
        aTag.click();
      },
      beforeSave(type) {
        // if (this.type == 'single') {
        //   this.showInvoice = true;
        // } else {
        //   this.saveHandle();
        // }
        this.handelData.isOffline = type;
        this.showInvoice = true;
      },
      beforeSubmit() {
        if (!this.limltIng) {
          let num = 0;
          if (this.handelData.actualBillingMain != null && this.handelData.actualBillingTakeOut != null) {
            num = Number(num) + this.handelData.actualBillingMain.details[0].taxInclusiveLabel == 0 ? (this.handelData.actualBillingMain.details[0].invoiceAmount * (this.rate + 1)).toFixed(2) : Number(this.handelData.actualBillingMain.details[0].invoiceAmount).toFixed(2)
            num = Number(num) + this.handelData.actualBillingMain.details[0].taxInclusiveLabel == 0 ? (Number(this.handelData.actualBillingMain.details[0].invoiceAmount * (this.rate + 1)) + Number(this.deductionAmountSum)).toFixed(2) : (Number(this.handelData.actualBillingMain.details[0].invoiceAmount) + Number(this.deductionAmountSum)).toFixed(2)
          } else if (this.handelData.actualBillingTakeOut != null && this.handelData.actualBillingMain == null) {
            num = Number(num) + Number(this.deductionAmountSum)
          } else if (this.handelData.actualBillingTakeOut == null && this.handelData.actualBillingMain != null) {
            num = Number(num) + Number(this.mTpt);
          }
          console.log('合计', num)
          if (Number(num) > Number(this.kysxed)) {
            this.$message.error('可用授信额度不足！')
          } else {
            this.saveHandle()
          }
        } else {
          this.$message.warning('查询可用额度中，请稍等')
        }
      },
      // 提交申请开票
      saveHandle() {
        if (this.handelData.isConsolidatedBilling != 1 && this.handelData.actualBillingTakeOut != null && !this.handelData.actualBillingTakeOut.billingItemId) {
          this.handelData.actualBillingTakeOut = null
        }
        console.log(this.handelData)
        this.isBtnLoading = true;
        xz.IvoiceFun(this.handelData, 'SetInvoiceChangeStatus').then(res => {
          if (res.status == 'ok') {
            this.actualInvoiceViewList = res.data;
            this.$message.success('开票成功！');
            // this.SendInvoiceEmail();
            this.isBtnLoading = false;
            this.isSuccess = true;
            this.showInvoice = false;

            // let actId = this.actualInvoiceViewList.toString();
            // let encode = encodeURI(window.location.href + '&status=back&actId=' + actId);
            // console.log(encode)
            // let base64 = btoa(encode)
            // this.loginForm.rzcghddz = base64;
            // this.loginForm.ycsbhddz = base64;
            // this.loginForm.fhdz = base64;
            // this.PostThirdParty_blueBilling()
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
            if (res.msg.indexOf('扫脸认证已超时') > -1) {
              setTimeout(() => {
                this.showAuthentication = true
              }, 500);
            } else if (res.msg.indexOf('登录') > -1) {
              setTimeout(() => {
                this.showLogin = true;
              }, 500);
            } else if (res.msg.indexOf('未查询到购买方纳税人信息') > -1) {
              this.errMsg = res.msg;
              this.errField = 'gmfxxsfqr';
              this.showConfirm = true;
            } else if (res.msg.indexOf('如确认受票方为单位') > -1) {
              this.errMsg = res.msg;
              this.errField = 'spflxqr';
              this.showConfirm = true;
            } else if (res.msg.indexOf('开具金额较大') > -1) {
              this.errMsg = res.msg;
              this.errField = 'sxeddefptxgz';
              this.showConfirm = true;
            }
          }
        })
      },
      //手工登记开票
      handelSign() {
        this.isBtnLoading = true;
        this.$set(this.handelData, 'isOffline', true);
        xz.IvoiceFun(this.handelData, 'SetInvoiceChangeStatus').then(res => {
          if (res.status == 'ok') {
            this.$message.success('手工登记开票成功！');
            this.isBtnLoading = false;
            this.isSuccess = true;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      // GetAId(id) {
      //   xz.GetInvoiceApplyForView(id).then(res => {
      //     if (res.status == 'ok') {
      //       if (res.data.length > 0) {
      //         this.actualInvoiceViewList = this.actualInvoiceViewList.concat(res.data[0].actualInvoiceViewList)
      //       }
      //     }
      //   })
      // },
      PostThirdParty_blueBilling() {
        let arr = []
        this.actualInvoiceViewList.forEach((element, index) => {
          // arr.push(element)
          let data = {
            actualBillingId: element,
            sfzsxsfyhzh: this.handelData.sfzsxsfyhzh,
            sfzsgmfyhzh: this.handelData.sfzsgmfyhzh,
            gmfxxsfqr: false
          }
          arr.push(data)
          if (this.actualInvoiceViewList.length == index + 1) {
            // let d = {
            //   actualBillingIds: arr
            // }
            xz.IvoiceFun(arr, 'PostThirdParty_blueBilling').then(res => {
              if (res.status == 'ok') {
                this.SendInvoiceEmail();
                this.$message.success('开票成功！');
                this.showInvoice = false;
                this.isBtnLoading = false;
                this.isSuccess = true;
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
                if (res.msg.indexOf('扫脸认证已超时') > -1) {
                  setTimeout(() => {
                    this.showAuthentication = true
                  }, 500);
                } else if (res.msg.indexOf('登录') > -1) {
                  setTimeout(() => {
                    this.showLogin = true;
                  }, 500);
                }
              }
            })
          }
        });
      },
      //发送邮件
      SendInvoiceEmail() {
        let data = {
          actualBillingId: [this.actualInvoiceViewList],
          isforce: true,
          wjlx: 'PDF'
        }
        xz.IvoiceFun(data, 'SendInvoiceEmail').then(res => {})
      },
      changeEwmlx() {
        this.QRCodeSrc = '';
        this.getQRCode();
      },
      //获取二维码
      getQRCode() {
        this.qrLoading = true;
        this.isTimeout = false;
        let data = {
          nsrsbh: this.loginForm.nsrsbh,
          areaid: this.loginForm.areaid,
          ewmlx: this.ewmlx
        }
        xz.IvoiceFun(data, 'PostThirdParty_queryAuthQrCode').then(res => {
          if (res.status == 'ok') {
            this.qrLoading = false;
            if (res.data.cwxx) {
              this.$message.error(res.data.cwxx)
            } else {
              this.QRCodeSrc = res.data.ewm;
              this.showAuthentication = true;
              this.times = 0;
              this.rzid = res.data.rzid;
              clearInterval(this.interval);
              setTimeout(() => {
                this.getQRStatus();
              }, 8000);
            }
          } else {}
        })
      },
      //获取扫码情况
      getQRStatus() {
        xz.PostThirdParty_queryAuthQrCode(this.rzid).then(res => {
          if (res.status == 'ok') {
            if (res.data == '进行中' && this.times < 59) {
              setTimeout(() => {
                this.getQRStatus()
              }, 2000);
            } else {
              if (res.data.rzzt == '2') {
                this.showAuthentication = false;
                this.$message.success('认证成功');
                this.saveHandle();
                clearInterval(this.interval);
              } else if (res.data.rzzt == '3') {
                this.$message.success('认证超时');
                this.isTimeout = true;
                clearInterval(this.interval);
              }
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      Refresh() {
        this.times++;
        this.getQRStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.times == 59) {
          this.times = 0;
          this.isTimeout = true;
          clearInterval(this.interval);
          // this.$message.warning('查询超时！')
        }
      },
      confirmLogin() {
        this.isBtnLoading = true;
        xz.IvoiceFun(this.loginForm, "PostThirdParty_asyncInit").then((res) => {
          if (res.status == "ok") {
            this.confirmLogin2()
          }
        })
      },
      confirmLogin2() {
        //PostThirdParty_asyncInit
        //PostThirdParty_generate
        xz.IvoiceFun(this.loginForm, "PostThirdParty_generate").then((res) => {
          if (res.status == "ok") {
            // if (res.data.cshzt == 1) {
            //   let dd = [{
            //     nsrsbh: this.loginForm.nsrsbh, //纳税人识别号
            //     areaid: this.loginForm.areaid, //行政区划代码
            //     sqlx: 2, //授权类型1:月授权2：年授权
            //     sfzdxd: false, //是否自动续订
            //     isf: false //是否强制订阅
            //   }]
            //   xz.IvoiceFun(dd, "PostThirdParty_subscribe").then((res) => {
            //     if (res.status == "ok") {
            //       this.isBtnLoading = false;
            //       this.$message.success("登录成功");
            //       this.showLogin = false;
            //       // this.getQRCode();
            //       this.showAuthentication = true; //认证
            //     } else {
            //       this.isBtnLoading = false;
            //       this.$message.error(res.msg);
            //     }
            //   });
            // }
            window.open(res.data, '_blank')
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        });
      },
      PostThirdParty_subscribe() {
        let dd = [{
          nsrsbh: this.loginForm.nsrsbh, //纳税人识别号
          areaid: this.loginForm.areaid, //行政区划代码
          sqlx: 2, //授权类型1:月授权2：年授权
          sfzdxd: false, //是否自动续订
          isf: false //是否强制订阅
        }]
        xz.IvoiceFun(dd, "PostThirdParty_subscribe").then((res) => {
          if (res.status == "ok") {
            this.isBtnLoading = false;
            // this.$message.success("登录成功");
            this.showLogin = false;
            // this.getQRCode();
            // this.saveHandle();
            // this.PostThirdParty_blueBilling();
            // this.showAuthentication = true; //认证
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
          }
        });
      },
      downInvoice() {
        this.showDown = true;
      },
      confirmDownInvoice() {
        this.isBtnLoading = true;
        let data = {
          id: this.actualInvoiceViewList[0],
          type: 1,
          wjlx: this.wjlx
        }
        xz.IvoiceFun(data, 'PostThirdParty_downloadFile').then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              if (res.data[0].data.jgzt == 1) {
                let url = res.data[0].data.wjdz;
                const aTag = document.createElement('a')
                aTag.href = url;
                aTag.click();
                this.isBtnLoading = false;
                this.showDown = false;
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.data[0].data.cwxx)
              }
            }
          }
        })
      },
      changeBilling(val) {
        console.log('111', val)
        if (val) {
          if (val.value.indexOf('差额') > -1 && this.handelData.actualBillingTakeOut == null) {
            this.handelData.actualBillingTakeOut = {
              billingItemId: '',
              invoiceTypeId: '',
              billingItemDetailsId: '',
              details: [{
                projectName: '',
                deductionAmount: 0,
                quantity: null,
                unit: null,
                specification: null,
              }],
            }
          } else if (val.value.indexOf('全额') > -1 && this.handelData.actualBillingMain == null) {
            this.handelData.actualBillingMain = {
              billingItemId: '',
              invoiceTypeId: "", //票种id
              details: [{
                billingItemDetailsId: "", //开票内容id
                taxInclusiveLabel: 0, //是否含税1：含税0：不含税
                invoiceAmount: 0, //金额
                quantity: null,
                unit: null,
                specification: null,
              }],
            }
          }
          if (this.handelData.isConsolidatedBilling == 1 || (this.handelData.actualBillingMain != null && this.handelData.isConsolidatedBilling == 0)) {
            this.handelData.actualBillingMain.billingItemId = val.key;
            this.handelData.actualBillingMain.invoiceTypeId = '';
            // this.handelData.actualBillingMain = {
            //   billingItemId: val.key,
            //   invoiceTypeId: "", //票种id
            //   details: [{
            //     billingItemDetailsId: "", //开票内容id
            //     taxInclusiveLabel: 0, //是否含税1：含税0：不含税
            //     invoiceAmount: 0, //金额
            //   }]
            // }
            this.invoiceTypeId = '';
            this.handelData.actualBillingMain.details[0].billingItemDetailsId = '';
            this.GetTicketType(val.key)
          } else {
            this.handelData.actualBillingTakeOut.details[0].billingItemId = val.key;
          }
          this.businessTypeId = val.businessTypeId;
          this.Billing = val.value;
          // this.GetBillingItemDetails(val.key)
          const regex = /\((.*?)\)/g;
          const matches = val.value.match(regex);
          let rate = matches.map(match => match.replace(/\(|\)/g, ''))[0];
          rate = rate.replace('%', '');
          this.rate = Number(rate) / 100;
        }
      },
      changeInvoiceType2(val) {
        let d = {
          key: this.handelData.actualBillingTakeOut.billingItemId,
          TicketTypeId: this.handelData.actualBillingTakeOut.invoiceTypeId,
          Projectid: this.ownershipId
        }
        xz.GetBillingItemDetails(d).then((res) => {
          if (res.status == "ok") {
            this.BillingConList2 = res.data;
          } else {
            this.BillingConList2 = [];
          }
        });
      },
      GetBillingItemDetails(key) {
        let d = {
          key,
          TicketTypeId: this.handelData.actualBillingMain != null ? this.handelData.actualBillingMain.invoiceTypeId : this.handelData.actualBillingTakeOut.invoiceTypeId,
          Projectid: this.ownershipId
        }
        xz.GetBillingItemDetails(d).then((res) => {
          if (res.status == "ok") {
            this.BillingConList = res.data;
            if (this.handelData.actualBillingMain != null) {
              this.changeBillingItemDetails(this.handelData.actualBillingMain.details[0].billingItemDetailsId);
            } else {
              this.changeBillingItemDetails(this.handelData.actualBillingTakeOut.details[0].billingItemDetailsId);
            }
            if (this.BillingConList2.length == 0) {
              this.BillingConList2 = res.data;
            }
            // if (this.handelData.actualBillingMain != null) {
            //   this.BillingConList.forEach(element => {
            //     if (element.key == this.handelData.actualBillingMain.details[0].billingItemDetailsId) {
            //       this.billingItemDetails = element;
            //     }
            //   });
            // }
          } else {
            this.BillingConList = [];
          }
        });
      },
      //选择开票内容
      changeBillingItemDetails(val) {
        if (val != undefined && val) {
          const item = this.BillingConList.find(e => e.key == val);
          if (item.value.indexOf('建筑服务') > -1) {
            this.isBuild = true;
          } else {
            this.isBuild = false;
          }
        } else {
          this.isBuild = false;
        }
      },
      //获取票种列表
      GetTicketType(key) {
        xz.GetTicketType(key, this.subjectOfLegalAffairsId).then(
          (res) => {
            if (res.status == "ok") {
              this.ticketTypeList = res.data;
              if ((this.handelData.actualBillingMain == null && this.handelData.actualBillingTakeOut != null) || (this.handelData.actualBillingMain != null && this.handelData.actualBillingTakeOut == null)) {
                this.ticketTypeList2 = this.ticketTypeList
              }
              this.ticketTypeList.forEach(element => {
                if (this.handelData.actualBillingMain != null) {
                  if (element.key == this.handelData.actualBillingMain.invoiceTypeId) {
                    this.invoiceTypeId = element;
                  }
                } else if (this.handelData.actualBillingTakeOut != null) {
                  if (element.key == this.handelData.actualBillingTakeOut.invoiceTypeId) {
                    this.invoiceTypeId = element;
                  }
                }
              });
            } else {
              this.ticketTypeList = [];
            }
          }
        );
      },
      changeBilling2(key, type) {
        xz.GetTicketType(key, this.subjectOfLegalAffairsId).then(
          (res) => {
            if (res.status == "ok") {
              this.ticketTypeList2 = res.data;
            } else {
              this.ticketTypeList2 = [];
            }
          })
        if (type == 'change') {
          this.handelData.actualBillingTakeOut.invoiceTypeId = ''
        }
      },
      //选择开票内容
      changeBillingItemDetails2(val) {
        if (val != undefined && val) {
          xz.GetTicketType(val, this.subjectOfLegalAffairsId).then(
            (res) => {
              if (res.status == "ok") {
                this.ticketTypeList2 = res.data;
              } else {
                this.ticketTypeList2 = [];
              }
            }
          );
        }
      },
      addKcItem() {
        let data = {
          billingItemDetailsId: '',
          projectName: '',
          deductionAmount: null
        }
        this.handelData.actualBillingTakeOut.details.push(data)
      },
      delKcItem(index) {
        this.handelData.actualBillingTakeOut.details.splice(index, 1)
        this.getDeductionAmountSum();
      },
      changeTicketTypeId(val) {
        if (val.key != undefined && val.key) {
          this.handelData.actualBillingMain.invoiceTypeId = val.key;
          this.GetBillingItemDetails(this.handelData.actualBillingMain.billingItemId);
          this.handelData.actualBillingMain.details[0].billingItemDetailsId = '';
        }
      },
      // 新增开票其他部分
      addContentHandle() {
        let query = {
          billingItemDetailsId: "", //开票内容id
          taxInclusiveLabel: 0, //是否含税1：含税0：不含税
          invoiceAmount: 0, //金额
        };
        this.handelData.actualBillingMain.details.push(query);
      },
      // 删除开票其他部分
      dltContentHandle(i) {
        this.handelData.actualBillingMain.details.splice(i, 1);
      },
      calMtpt() {
        let sum = 0;
        this.handelData.actualBillingMain.details.forEach(e => {
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(e.invoiceAmount))
            )
          )
        });
        this.mTpt = parseFloat(sum);
      },
      //发票预览
      invView(i) {
        this.mainInfo = null;
        this.outInfo = null;
        this.invList = [];
        //Main部分
        if (this.handelData.actualBillingMain != null) {
          let d = {
            methods: 1,
            isBuild: false, //是否建筑行业
            ticketType: '', //票种
            rate: '', //税率
            details: [],
            totalAmount: 0, //合计
            totalTax: 0, //税额合计
            totalTaxPrice: 0 //价税合计
          }
          //票种
          const ticketType = this.ticketTypeList.find(e => e.key == this.handelData.actualBillingMain.invoiceTypeId);
          d.ticketType = ticketType.value;

          //税率
          const rateItem = this.BillingList.find(e => e.key == this.handelData.actualBillingMain.billingItemId);
          const regex = /\((.*?)\)/g;
          const matches = rateItem.value.match(regex);
          let rate = matches.map(match => match.replace(/\(|\)/g, ''))[0];
          rate = rate.replace('%', '');
          d.rate = Number(rate) / 100;


          //开票内容
          this.handelData.actualBillingMain.details.forEach(element => {
            const billingItem = this.BillingConList.find(e => e.key == element.billingItemDetailsId);
            let amount = element.taxInclusiveLabel == 0 ? element.invoiceAmount : element.invoiceAmount / (1 + d.rate);
            amount = amount.toFixed(2);
            let taxAmount = element.taxInclusiveLabel == 0 ? element.invoiceAmount * d.rate : element.invoiceAmount - element.invoiceAmount / (1 + d.rate);
            taxAmount = taxAmount.toFixed(2)
            let c = {
              billingItem: billingItem.value,
              amount: Math.round(amount * 100) / 100,
              taxAmount: Math.round(taxAmount * 100) / 100,
              quantity: element.quantity,
              unit: element.unit,
              specification: element.specification,
            }
            if (c.billingItem.indexOf('*建筑服务*') > -1) {
              d.isBuild = true;
            }
            d.totalAmount = math.format(
              math.add(
                math.bignumber(Number(d.totalAmount)), math.bignumber(Number(c.amount))
              )
            )
            d.totalTax = math.format(
              math.add(
                math.bignumber(Number(d.totalTax)), math.bignumber(Number(c.taxAmount))
              )
            )
            d.totalTaxPrice = math.format(
              math.add(
                math.bignumber(Number(d.totalTaxPrice)), math.bignumber(Number(d.totalAmount))
              )
            )
            d.totalTaxPrice = math.format(
              math.add(
                math.bignumber(Number(d.totalTaxPrice)), math.bignumber(Number(c.taxAmount))
              )
            )
            // d.totalTaxPrice = Number(d.totalTaxPrice) + Number(d.totalAmount) + Number(c.taxAmount)
            d.details.push(c)
          });
          this.mainInfo = d;
        }

        // TakeOut部分
        if (this.handelData.actualBillingTakeOut != null) {
          let d = {
            methods: 2,
            isBuild: false, //是否建筑行业
            ticketType: '', //票种
            rate: '', //税率
            details: [],
            totalAmount: 0,
            totalTaxPrice: 0
          }
          if (this.handelData.isConsolidatedBilling == 1) {
            const ticketType = this.ticketTypeList.find(e => e.key == this.handelData.actualBillingMain.invoiceTypeId);
            d.ticketType = ticketType.value;

          } else {
            //票种
            const ticketType = this.ticketTypeList2.find(e => e.key == this.handelData.actualBillingTakeOut.invoiceTypeId);
            d.ticketType = ticketType.value;
          }

          //税率
          if (this.handelData.isConsolidatedBilling == 0) {
            console.log(this.ticketTypeList2, this.handelData.actualBillingTakeOut.invoiceTypeId)
            const rateItem = this.BillingList.find(e => e.key == this.handelData.actualBillingTakeOut.billingItemId);
            const regex = /\((.*?)\)/g;
            const matches = rateItem.value.match(regex);
            let rate = matches.map(match => match.replace(/\(|\)/g, ''))[0];
            rate = rate.replace('%', '');
            d.rate = Number(rate) / 100;
          }


          //开票内容
          if (this.handelData.actualBillingTakeOut.details.length > 0) {
            this.handelData.actualBillingTakeOut.details.forEach((element, index) => {
              let c = {
                billingItem: '',
                amount: Number(element.deductionAmount),
                taxAmount: 0,
                quantity: element.quantity,
                unit: element.unit,
                specification: element.specification,
              }
              if (this.handelData.isConsolidatedBilling == 1) {
                d.totalAmount = math.format(
                  math.add(
                    math.bignumber(Number(d.totalAmount)), math.bignumber(Number(element.deductionAmount))
                  )
                )
                d.totalTaxPrice = d.totalAmount
                d.details.push(c)
                this.outInfo = d;
              } else {
                const billingItem = this.BillingConList2.find(e => e.key == element.billingItemDetailsId);
                c.billingItem = billingItem.value;
                if (c.billingItem.indexOf('*建筑服务*') > -1) {
                  d.isBuild = true;
                }

                if (index == 0) {
                  d.totalAmount = Number(element.deductionAmount)
                  d.details.push(c)
                  // this.outInfo = d;
                  this.invList.push(d)
                } else {
                  c.amount = Number(element.deductionAmount)
                  let a = {
                    methods: 2,
                    isBuild: d.isBuild, //是否建筑行业
                    ticketType: d.ticketType, //票种
                    rate: d.rate, //税率
                    details: [c],
                    totalAmount: Number(element.deductionAmount)
                  }
                  this.invList.push(a)
                }
              }
            });
          }

        }
        setTimeout(() => {
          //不合并
          if (this.handelData.isConsolidatedBilling != 1) {
            if (this.mainInfo != null) {
              this.invList.push(this.mainInfo)
            }
            if (this.outInfo != null) {
              this.invList.push(this.outInfo)
            }
          } else { //合并
            let d = this.mainInfo;
            d.details[0].amount = math.format(
              math.add(
                math.bignumber(Number(d.details[0].amount)), math.bignumber(Number(this.outInfo.details[0].amount))
              )
            )
            d.methods = 2;
            d.totalAmount = math.format(
              math.add(
                math.bignumber(Number(d.totalAmount)), math.bignumber(Number(this.outInfo.totalAmount))
              )
            )
            d.totalDeductionAmount = this.outInfo.totalAmount;
            d.totalTaxPrice = math.format(
              math.add(
                math.bignumber(Number(d.totalTaxPrice)), math.bignumber(Number(this.outInfo.totalTaxPrice))
              )
            )
            this.invList.push(d)
          }
          // console.log(this.invList)
          this.showInvView = true;
        }, 100);

      },
      //数字转中文大写
      numberToChinese(money) {
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      changeConsolidatedBilling(val) {
        if (val == 1) {
          this.handelData.actualBillingTakeOut.details[0].billingItemDetailsId = '';
          this.handelData.actualBillingTakeOut.invoiceTypeId = '';
        }
      },
      confirmContinue() {
        this.handelData[this.errField] = true;
        this.showConfirm = false;
        this.saveHandle()
      },
      confirmEditBillingNote() {
        this.isBtnLoading = true;
        let d = {
          invoiceId: this.handelData.invoiceId,
          billingNote: this.appInfo[0].billingNote
        }
        xz.IvoiceFun(d, "SetInvoiceRemarkEdit").then((res) => {
          if (res.status == "ok") {
            this.isBtnLoading = false;
            this.isEdit = false;
            this.$message.success('修改成功');
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
          }
        });
      },
    }
  }
</script>
<style scoped>
  .down_txt {
    font-size: 14px;
    color: #409EFF;
    margin-left: 20px;
  }

  .record_item {
    padding: 10px;
    color: #555;
    font-size: 14px;
    box-shadow: 0px 4px 6px 0px rgba(104, 11, 255, 0.02);
    background-color: #f2f3f3;
    margin-bottom: 10px;
  }

  .mt15 {
    margin-top: 15px;
  }

  .record_item p {
    margin-top: 5px;
  }

  .s_tabs_box {
    background-color: #fff;
  }

  .step_box {
    background-color: #fff;
    padding: 15px 10px;
    min-height: 300px;
  }

  .f_input_box {
    display: flex;
    margin-top: 20px;
  }

  .f_txt {
    width: 80px;
    font-size: 14px;
    color: #555;
  }

  .f_input_right {
    flex: 1;
  }

  .print_box {
    justify-content: flex-end;
    margin-right: 40px;
  }


  .com_form_box {
    margin: 50px 0;
    padding: 0 20px;
  }


  .d_txt {
    font-size: 14px;
    color: #555;
    margin-top: 20px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 120px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .emp_form_txt {
    width: 360px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }

  .nums {
    margin-left: 80px;
    font-size: 13px;
    font-weight: 400;
  }

  .qrTips {
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
  }

  .ceBox {
    padding-left: 30px;
    padding-bottom: 20px;
  }

  .ceTitle {
    font-weight: bold;
    font-size: 14px;
    padding-top: 9px;
  }

  .ckbox {
    margin-left: 78px;
    margin-bottom: 10px;
  }

  .chkBox {
    padding-left: 10px;
    font-size: 14px;
  }

  .merge {
    padding: 10px 30px;
  }

  .emailBox {
    margin-top: 15px;
  }

  .emails {
    margin: 0 20px;
    font-size: 14px;
  }

  .inv_box {
    border-bottom: #ccc 2px dashed;
    margin-bottom: 15px;
  }

  .ceBox {
    padding-left: 30px;
    padding-bottom: 20px;
  }

  .ceTitle {
    font-weight: bold;
    font-size: 14px;
    padding-top: 9px;
  }

  .kcTitle {
    line-height: 32px;
    margin-right: 2px;
    white-space: nowrap;
  }

  .ckbox2 {
    margin-left: 40px;
    margin-bottom: 10px;
  }

  .huo {
    line-height: 32px;
    margin: 0 5px 0 10px;
    font-size: 14px;
    white-space: nowrap;
  }

  .req {
    color: red;
    margin-right: 8px;
  }

  .sumAmount {
    font-weight: bold;
    margin-left: 150px;
  }

  .addbtn {
    line-height: 32px;
    white-space: nowrap;
  }

  .deductionAmountSum {
    margin-left: 30px;
    font-weight: bold;
    line-height: 32px;
    white-space: nowrap;
  }

  .tabBox {
    background: #fff;
    padding: 30px;
    /* width: 800px; */
  }

  .invTitle {
    width: 800px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .reimbursementTitle {
    text-align: center;
    margin-bottom: 3px;
    font-size: 24px;
    color: #800000;
  }

  .invType {
    margin-left: 30px;
    font-size: 14px;
    color: #000;
    min-width: 150px;
  }

  .invNum {
    color: #800000;
    margin-bottom: 5px;
  }

  .centerTitle {
    margin-bottom: 5px;
    font-size: 20px;
  }

  .invoiceTable {
    margin-top: 10px;
    width: 800px;
    background-color: #fff;
    padding: 8px 0;
    /* line-height: 40px; */
  }

  .tabBox table td,
  .tabBox table th {
    border: #800000 1px solid !important;
  }

  .tabBox table {
    border: #800000 1px solid !important;
  }

  .tabBox_title {
    background: #f6f6f6;
  }

  .font-center {
    text-align: center
  }

  .titfont {
    font-family: 微软雅黑;
    padding: 10px 0;
    color: #800000;
  }

  .titfont2 {
    padding: 20px 0;
  }

  .rowItem {
    font-size: 14px;
    padding-left: 5px;
  }

  .mt {
    margin-top: 30px;
  }

  .rowTitle {
    font-size: 13px;
    color: #800000;
  }

  .invInfoBox {
    height: 180px;
    padding: 5px 0;
    position: relative;
  }

  .invItem {
    width: 100px;
    text-align: center;
    color: #800000;
  }

  .invInfoLine {
    margin-top: 5px;
    color: #000;
  }

  .invInfoItem {
    text-align: center;
    width: 100px;
  }

  .invInfoBot {
    position: absolute;
    bottom: 5px;
  }

  .amountLine {
    line-height: 32px;
  }

  .invRemake {
    margin-left: 5px;
    margin-right: 10px;
  }

  /* 水印 */
  .invInfoBox::before {
    content: "仅供开票预览";
    position: absolute;
    top: 12%;
    left: 24%;
    transform: translate(-50%, -50%);
    transform: rotate(30deg);
    opacity: 0.4;
    letter-spacing: 20px;
    font-size: 54px;
    color: #ccc;
    position: none;
  }

  .invTop {
    border-top: #CCC 2px dashed;
    margin-bottom: 25px;
  }

  .limltTitle {
    min-width: 140px;
    text-align: right;
    font-size: 14px;
    line-height: 32px;
  }

  .limlt {
    font-weight: bold;
    font-size: 14px;
    min-width: 120px;
    padding-left: 5px;
    line-height: 32px;
  }

  .icon-01 {
    font-size: 16px;
    margin-left: 5px;
    color: #409EFF;
  }

  .tips {
    color: red;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }
</style>
<style>
  .page_pendInvoiceMul .dtl_table .el-table,
  .page_pendInvoiceMul .el-table th.el-table__cell {
    background-color: #E8F7F7;
    /* 你想要的背景色 */
  }

  .form_table td {
    border: #000 1px solid;
  }

  .e_dtl_content .el-table .el-table__cell {
    padding: 4px 0;
  }

  .dialog_box .el-dialog__body {
    padding: 10px 20px;
  }

  /* .page_pendInvoiceMul .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_pendInvoiceMul .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  } */
  .page_pendInvoiceMul .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>